<template>
  <div id="contenedor-agregar-nueva-actividad">
    <v-form ref="crearActividad" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva actividad
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-area
          v-model="actividad.descripcion"
          label="Descripción"
          :rules="[mixReglas.requerido]"
          required>
          </custom-text-area>
          <v-row>
            <v-col>
              <custom-select
              v-model="actividad.estatus"
              label="Estatus"
              :items="itemsestatus"
              :rules="[mixReglas.requerido]"
              required>
              </custom-select>
            </v-col>
            <v-col>
              <custom-date-picker
              v-model="actividad.fechaPlazo"
              label="Fecha Plazo">
              </custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixCrearActividad"
            :disabled="!esformularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixActividades from './mixActividades';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarNuevaActividad',
  mixins: [mixActividades],
  props: {
    idReferenciaActividad: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomSelect,
    CustomTextArea,
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
      esformularioValido: false,
      itemsestatus: ['Abierta', 'Cerrada', 'Cancelada'],
      actividad: {
        idReferencia: this.idReferenciaActividad,
        descripcion: '',
        estatus: '',
        fechaPlazo: null,
        responsables: [],
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.crearActividad.reset();
    },
  },

};
</script>

<style>

</style>
